
import { _id } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  contact: '/contact-us',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
  },
  compilazioneQuestionarioEsterna: {
    new: '/compilaQuestionario'
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
    general: {
      app: `${ROOTS.DASHBOARD}app`
    },
    cliente: {
      root: `${ROOTS.DASHBOARD}cliente/list`,
      new: `${ROOTS.DASHBOARD}cliente/new`,
      aggregation : `${ROOTS.DASHBOARD}cliente/aggregation`,
      edit: (id: string) => `${ROOTS.DASHBOARD}cliente/${id}/edit`,
      profile: (id: string) => `${ROOTS.DASHBOARD}cliente/${id}/profile`,
      account: `${ROOTS.DASHBOARD}cliente/account`,
      campiExtraList: `${ROOTS.DASHBOARD}cliente/campiExtra`,
      campoExtraNew: `${ROOTS.DASHBOARD}cliente/campoExtra/new`,
      campoExtraEdit: (id: string) => `${ROOTS.DASHBOARD}cliente/campoExtra/${id}/edit`,
    },
    clienteScreen: {
      root: `${ROOTS.DASHBOARD}cliente-screen`,
    },
    avatar: {
      root: `${ROOTS.DASHBOARD}avatar`,
    },
    mappaClienti: {
      root: `${ROOTS.DASHBOARD}mappa-clienti`,
    },
    consulente: {
      root: `${ROOTS.DASHBOARD}consulente/list`,
      new: `${ROOTS.DASHBOARD}consulente/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}consulente/${id}/edit`,
      profile: (id: string) => `${ROOTS.DASHBOARD}consulente/${id}/profile`,
    },

    account:{
      root: `${ROOTS.DASHBOARD}account`,
      changePassword: `${ROOTS.DASHBOARD}account/change-password`,
      notifications: `${ROOTS.DASHBOARD}account/notifications`,
      settingsUIConsulenti: `${ROOTS.DASHBOARD}account/settings-ui-consulenti`,
    },
    portafogliModello: {
      root: `${ROOTS.DASHBOARD}portafogli-modello`,
    },
    articoli: {
      root: `${ROOTS.DASHBOARD}articoli`,
      details: (id: string) => `${ROOTS.DASHBOARD}articoli/${id}`,
    },
    compilazione: {
      root: `${ROOTS.DASHBOARD}compilazione/list`,
      new: `${ROOTS.DASHBOARD}compilazione/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}compilazione/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}compilazione/${id}/edit`,
    },
    firmaPdf: {
      root: `${ROOTS.DASHBOARD}firma-pdf`,
    },
    corsoCrm: {
      root: `${ROOTS.DASHBOARD}corso-crm`,
    },
    forecast: {
      root: `${ROOTS.DASHBOARD}forecast`,
    },
    businessTraining: {
      root: `${ROOTS.DASHBOARD}business-training`,
      gestione: `${ROOTS.DASHBOARD}business-training/gestione`,
    },
    testiPdf: {
      root: `${ROOTS.DASHBOARD}testi-pdf`,
    },
    permessi: {
      root: `${ROOTS.DASHBOARD}permessi-consulenti`,
    },
    emergenza: {
      root: `${ROOTS.DASHBOARD}emergenza-piattaforma`,
    },
    // Vista Beginner (il beginner) e relativa gestione (solo Amministratore e Backoffice)
    beginner: {
      root: `${ROOTS.DASHBOARD}beginner`,
      documenti: `${ROOTS.DASHBOARD}beginner/documenti`,
      scheda: `${ROOTS.DASHBOARD}beginner/scheda`,
      // formazione: pagina nascosta per ora (v. sections/vista-beginner/beginner-formazione-data.ts)
      // formazione: `${ROOTS.DASHBOARD}beginner/formazione`,
      ocf: `${ROOTS.DASHBOARD}beginner/ocf`,
    },
    beginnerGestione: {
      root: `${ROOTS.DASHBOARD}beginner-gestione`,
      details: (id: string | number) => `${ROOTS.DASHBOARD}beginner-gestione/${id}`,
    },
    areaManager: {
      assegnazione: `${ROOTS.DASHBOARD}area-manager/clienti-diretti/assegnazione`,
      distribuzione: `${ROOTS.DASHBOARD}area-manager/clienti-diretti/distribuzione`,
      firmaScheda: `${ROOTS.DASHBOARD}area-manager/firma-scheda`,
      schedaBeginner: `${ROOTS.DASHBOARD}area-manager/scheda-beginner`,
      firmaTeam: `${ROOTS.DASHBOARD}area-manager/firma-accordi-team`,
      reclutamento: `${ROOTS.DASHBOARD}area-manager/reclutamento/dashboard`,
    },
    staff: {
      plancia: `${ROOTS.DASHBOARD}staff/plancia`,
      gantt: `${ROOTS.DASHBOARD}staff/gantt`,
      planciaFrancesco: `${ROOTS.DASHBOARD}staff/plancia-francesco`,
      pianoEditoriale: `${ROOTS.DASHBOARD}staff/piano-editoriale`,
    },
    statistiche: {
      root: `${ROOTS.DASHBOARD}statistiche`,
    },
    statisticheApp: {
      root: `${ROOTS.DASHBOARD}statistiche-app`,
    },
    eventi: {
      root: `${ROOTS.DASHBOARD}eventi`,
      details: (id: string) => `${ROOTS.DASHBOARD}eventi/${id}`,
    },
    group: {
      root: `${ROOTS.DASHBOARD}group/list`,
      new: `${ROOTS.DASHBOARD}group/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}group/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}group/${id}/edit`,
    },
    notification:{
      root: `${ROOTS.DASHBOARD}notification/list`,
      new: `${ROOTS.DASHBOARD}notification/new`,
    }
  },
};
